import { PropsWithChildren, useEffect } from 'react';
import { SDKResponse } from '@commercetools/frontend-sdk';
import { PageResponse } from '@commercetools/frontend-sdk/lib/types/api/page';

export const TracingProvider = ({
  children,
  page,
}: PropsWithChildren<{ page: SDKResponse<PageResponse> }>) => {
  const { frontasticRequestId } = page.tracing!;

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log(`Frontastic-Request-ID: ${frontasticRequestId!}`);
  }, [frontasticRequestId]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
